/* KONFIGURÁTOR VÝBAVY — logika sekce `ktm-konfigurator`.
 *
 * Data přicházejí ze dvou <script type="application/json"> uvnitř sekce:
 *   data-kkf-data     díly, kategorie, pravidla (robot konfigurator_data.py)
 *   data-kkf-rendery  motorka s posazeným dílem (jen 12 silničních modelů)
 *
 * Pravidla PIM:
 *   m = MUSSARTIKEL  „k tomuhle musíš přidat i…"  → okno, potvrzení přidá vše
 *   x = EXCLUDEART   „tohle spolu nejde"          → tlačítko zšedne s důvodem
 *
 * ⛔ Ceny se nikde nepočítají znovu — vozí se z metapole (naše ceny z ABRY).
 */
(function () {
  "use strict";

  var IKONA_PLUS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  var IKONA_KOS = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 7h12M9 7V5h6v2m-8 0l1 13h8l1-13" fill="none" stroke="currentColor" stroke-width="2"/></svg>';

  // ⛔ Slova sedí na metapole `custom.dostupnost` a na to, co říká karta
  //    i AI rádce. Pořadí = číslo, které posílá robot konfigurator_data.py.
  var DOSTUPNOST = ["Skladem ve Vlašimi", "Skladem u dodavatele",
    "Známý termín naskladnění", "Na objednání", "Dočasně nedostupné",
    "Nedostupné nikde", "Dostupnost na dotaz"];
  var SKLADEM_DO = 1;   // „jen skladem" = ve Vlašimi nebo u dodavatele

  function datumCz(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
    return m ? Number(m[3]) + ". " + Number(m[2]) + ". " + m[1] : "";
  }
  // Text dostupnosti jako na kartě produktu: kusy ve Vlašimi (ks), kusy
  // u dodavatele (kd), termín (e). Vít 15. 9.: „my ten termín známe, tak proč
  // ho tam nenapíšeme — ať to tam přiznáme".
  function dostText(d) {
    var t = DOSTUPNOST[d.d] || "";
    if (d.d === 0 && d.ks) return t + " – " + d.ks + " ks";
    if (d.d === 1 && d.kd) return t + " – " + d.kd + " ks";
    if (d.d === 2 && d.e) return "U dodavatele od " + datumCz(d.e);
    return t;
  }

  // čeština má tři tvary: 1 díl · 2–4 díly · 5+ dílů
  function sklonuj(n, jeden, dva, pet) {
    if (n === 1) return jeden;
    return n >= 2 && n <= 4 ? dva : pet;
  }

  function korunu(n) {
    if (n == null) return "";
    return new Intl.NumberFormat("cs-CZ", {
      style: "currency", currency: "CZK", maximumFractionDigits: 0
    }).format(n);
  }

  function el(tag, tridy, text) {
    var e = document.createElement(tag);
    if (tridy) e.className = tridy;
    if (text != null) e.textContent = text;
    return e;
  }

  // diakritika pryč, ať „ridítka“ najde i „riditka“
  function bezDiakritiky(s) {
    return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  }

  function Konfigurator(korenElement) {
    var koren = korenElement;
    var uzelData = koren.querySelector("[data-kkf-data]");
    if (!uzelData) return;

    var data;
    try {
      data = JSON.parse(uzelData.textContent);
    } catch (e) {
      console.error("[konfigurátor] data se nedají přečíst", e);
      return;
    }
    var rendery = null;
    var uzelR = koren.querySelector("[data-kkf-rendery]");
    if (uzelR) {
      try { rendery = JSON.parse(uzelR.textContent); } catch (e) { rendery = null; }
    }

    var cdn = data.cdn || "";
    var dily = data.dily || [];
    var podleArtiklu = {};
    dily.forEach(function (d) { podleArtiklu[d.a] = d; });

    // Dva seznamy, ať jde spolehlivě odebírat:
    //   zvolene = co si člověk vybral sám
    //   vybrano = zvolené + povinné příslušenství (dopočítává se vždy znovu)
    // ⛔ Nepřičítat/neodečítat přírůstkově — z toho vznikaly osiřelé zámky kufru.
    var zvolene = new Set();
    var vybrano = new Set();
    var uhelIx = 0;               // který úhel renderu je vidět
    var hledanyText = "";
    var jenSkladem = false;

    // Předpočítané mapy — počítat je při každém překreslení 412 karet znamenalo
    // 433 ms na jeden klik (změřeno 14. 9. na 300 EXC). Nezávisí na výběru.
    var POVINNE = {};   // artikl -> Set povinného příslušenství (tranzitivně, bez sebe)
    var KONFLIKT = {};  // artikl -> Set dílů, se kterými nejde dohromady (obě strany)
    dily.forEach(function (d) {
      KONFLIKT[d.a] = KONFLIKT[d.a] || new Set();
      (d.x || []).forEach(function (b) {
        if (!podleArtiklu[b]) return;
        KONFLIKT[d.a].add(b);
        KONFLIKT[b] = KONFLIKT[b] || new Set();
        KONFLIKT[b].add(d.a);
      });
    });

    var q = koren.querySelector.bind(koren);
    var uzly = {
      platno: q("[data-platno]"), zaklad: q("[data-zaklad]"),
      scenaObal: koren.querySelector(".kkf-scena-obal"), scena: q("[data-scena]"),
      scenaStav: q("[data-scena-stav]"), tecky: q("[data-tecky]"),
      kategorie: q("[data-kategorie]"), prazdno: q("[data-prazdno]"),
      hledani: q("[data-hledani]"), hledaniX: q("[data-hledani-x]"),
      jenSkladem: q("[data-jen-skladem]"),
      vybrano: q("[data-vybrano]"), cipy: q("[data-cipy]"),
      vybranoPocet: q("[data-vybrano-pocet]"),
      pocet: q("[data-pocet]"), listaPocet: q("[data-lista-pocet]"),
      cenaMoto: q("[data-cena-moto]"), cenaDily: q("[data-cena-dily]"),
      cenaCelkem: q("[data-cena-celkem]"),
      doKosiku: q("[data-do-kosiku]"), doKosikuText: q("[data-do-kosiku-text]"),
      sdilet: q("[data-sdilet]"), hlaska: q("[data-hlaska]"),
      modal: q("[data-kkf-modal]"), modalTelo: q("[data-kkf-modal-telo]"),
      modalCena: q("[data-kkf-modal-cena]"), modalOk: q("[data-kkf-modal-ok]")
    };

    /* ---------- pravidla ---------- */

    // Co všechno musí přijít s dílem (tranzitivně — kufr chce zámek, zámek chce kabeláž).
    // `uz` = co se nemá vypisovat znovu (už to ve výbavě je).
    // 🧨 Pravidla PIM jsou VZÁJEMNÁ (kufr ↔ nosič), takže se tu chodí v kruhu.
    //    Bez `koren` se díl vracel sám sobě a v okně i v ceně byl dvakrát
    //    (nález z testu 14. 9. na „Cestovní sada kufrů": 48 527 místo 26 682 Kč).
    function _potreba(artikl, sebrane, korenArtikl) {
      var d = podleArtiklu[artikl];
      if (!d || !d.m) return sebrane;
      d.m.forEach(function (a) {
        if (a === korenArtikl || sebrane.has(a) || !podleArtiklu[a]) return;
        sebrane.add(a);
        _potreba(a, sebrane, korenArtikl);
      });
      return sebrane;
    }

    // Celý povinný uzávěr dílu (bez něj samého). Počítá se jednou a pamatuje.
    function povinne(artikl) {
      if (!POVINNE[artikl]) POVINNE[artikl] = _potreba(artikl, new Set(), artikl);
      return POVINNE[artikl];
    }

    // Co z povinného uzávěru ve výbavě ještě není
    function potrebaPro(artikl, uz) {
      var ven = new Set();
      povinne(artikl).forEach(function (a) { if (!uz || !uz.has(a)) ven.add(a); });
      return ven;
    }

    // vybrano = zvolené + všechno, co k nim výrobce povinně váže
    function prepocitejVybrano() {
      var ven = new Set(zvolene);
      zvolene.forEach(function (a) {
        povinne(a).forEach(function (b) { ven.add(b); });
      });
      vybrano = ven;
    }

    // Který díl z dané sady brání tomuhle (obě strany vazby EXCLUDEART)
    function kolizeSV(artikl, sada) {
      var ven = [];
      (KONFLIKT[artikl] || new Set()).forEach(function (a) {
        if (a !== artikl && sada.has(a)) ven.push(a);
      });
      return ven;
    }

    function kolizeS(artikl) { return kolizeSV(artikl, vybrano); }

    // 🧨 Povinné příslušenství umí do výbavy přitáhnout díl, se kterým je
    //    vybíraný kus v konfliktu (790 Adventure: „Nosič topcase" si vyžádá
    //    řetěz dílů, na jehož konci je kufr Touratech, a ten s ním nejde
    //    dohromady). Nález auditu 14. 9. — proto se kontroluje CELÁ sada,
    //    která by po přidání vznikla, ne jen kliknutý díl.
    //    Vrací větu pro zákazníka, nebo null když díl přidat jde.
    function duvodBlokace(artikl) {
      if (vybrano.has(artikl)) return null;
      var prime = kolizeS(artikl);
      if (prime.length) return "Nejde dohromady s: " + nazvy(prime);

      // `vybrano` je vždy bez sporu, takže stačí prověřit jen to, co by přibylo
      var navrh = new Set(vybrano);
      navrh.add(artikl);
      povinne(artikl).forEach(function (a) { navrh.add(a); });

      var spory = [];
      var nove = [artikl];
      povinne(artikl).forEach(function (a) { if (!vybrano.has(a)) nove.push(a); });
      nove.forEach(function (a) {
        kolizeSV(a, navrh).forEach(function (b) {
          var par = [a, b].sort().join("|");
          if (spory.indexOf(par) === -1) spory.push(par);
        });
      });
      if (!spory.length) return null;
      var dvojice = spory[0].split("|");
      return "Nejde přidat: výrobce k němu povinně váže „" + nazvy([dvojice[0]])
        + "“, a to nejde dohromady s „" + nazvy([dvojice[1]]) + "“.";
    }

    function nazvy(artikly) {
      return artikly.map(function (a) {
        return (podleArtiklu[a] || {}).t || a;
      }).join(", ");
    }

    /* ---------- výběr ---------- */

    // Přidaný díl se na motorce musí UKÁZAT (Vít 16. 9.: „po kliknutí se neobjeví"):
    // polovina dílů je z výchozího úhlu drobná (medián 0,6 % obrázku), tak se
    // motorka otočí do úhlu, kde je díl největší, a díl se na chvíli rozsvítí.
    var zvyraznit = null;
    function ukazNaMotorce(artikl) {
      if (!maRender(artikl)) return;
      zvyraznit = artikl;
      var plochy = rendery.pl && rendery.pl[artikl];
      if (!plochy || !rendery.uhly) return;
      var ted = plochy[rendery.uhly[uhelIx]] || 0;
      var nej = rendery.uhly[uhelIx], nejPlocha = ted;
      rendery.uhly.forEach(function (u) {
        if ((plochy[u] || 0) > nejPlocha) { nej = u; nejPlocha = plochy[u]; }
      });
      // otočit jen když to opravdu pomůže: teď je díl malý a jinde aspoň 2× větší
      if (ted < 3000 && nejPlocha >= 2 * Math.max(ted, 1)) uhelIx = rendery.uhly.indexOf(nej);
    }

    function pridej(artikl) {
      if (duvodBlokace(artikl)) return;
      var potreba = potrebaPro(artikl, vybrano);
      if (potreba.size) {
        oknoPotreby(artikl, Array.from(potreba));
        return;
      }
      zvolene.add(artikl);
      ukazNaMotorce(artikl);
      poZmene();
    }

    // Odebrat jde i díl, který přišel jako povinná příloha — pak zmizí
    // i to, co si ho vyžádalo (jinak by v košíku byl kufr bez zámku).
    function odeber(artikl) {
      zvolene.delete(artikl);
      Array.from(zvolene).forEach(function (a) {
        if (povinne(a).has(artikl)) zvolene.delete(a);
      });
      poZmene();
    }

    function oknoPotreby(artikl, potreba) {
      var hlavni = podleArtiklu[artikl];
      uzly.modalTelo.innerHTML = "";
      uzly.modalTelo.appendChild(el("p", "kkf-modal-skupina", "Vybraný díl"));
      uzly.modalTelo.appendChild(kartaDilu(hlavni, { bezTlacitka: true }));
      uzly.modalTelo.appendChild(el("p", "kkf-modal-skupina",
        potreba.length === 1 ? "Musí se přidat i" : "Musí se přidat i tyhle"));
      potreba.forEach(function (a) {
        if (podleArtiklu[a]) uzly.modalTelo.appendChild(kartaDilu(podleArtiklu[a], { bezTlacitka: true }));
      });
      var suma = (hlavni.c || 0) + potreba.reduce(function (s, a) {
        return s + ((podleArtiklu[a] || {}).c || 0);
      }, 0);
      uzly.modalCena.textContent = korunu(suma);
      uzly.modalOk.onclick = function () {
        zvolene.add(artikl);      // povinné doplní prepocitejVybrano()
        zavriModal();
        ukazNaMotorce(artikl);
        poZmene();
      };
      otevriModal();
    }

    var vraceniFokusu = null;
    function otevriModal() {
      vraceniFokusu = document.activeElement;
      uzly.modal.hidden = false;
      document.body.style.overflow = "hidden";
      uzly.modalOk.focus();
      document.addEventListener("keydown", klavesaModal);
    }
    function zavriModal() {
      uzly.modal.hidden = true;
      document.body.style.overflow = "";
      document.removeEventListener("keydown", klavesaModal);
      if (vraceniFokusu && vraceniFokusu.focus) vraceniFokusu.focus();
    }
    function klavesaModal(e) {
      if (e.key === "Escape") { zavriModal(); return; }
      if (e.key !== "Tab") return;
      var f = uzly.modal.querySelectorAll("button, [href], input, select, textarea");
      if (!f.length) return;
      var prvni = f[0], posledni = f[f.length - 1];
      if (e.shiftKey && document.activeElement === prvni) { e.preventDefault(); posledni.focus(); }
      else if (!e.shiftKey && document.activeElement === posledni) { e.preventDefault(); prvni.focus(); }
    }
    koren.querySelectorAll("[data-kkf-zavri]").forEach(function (b) {
      b.addEventListener("click", zavriModal);
    });

    /* ---------- vykreslení ---------- */

    // Jen to, co se mění s výběrem — volá se při každé změně místo přestavby
    // celého seznamu. ⚠ Přestavba 412 karet stála 433 ms na klik (změřeno
    // 14. 9. na 300 EXC), takhle je to pod 20 ms.
    function stavKarty(radek, d) {
      var ma = vybrano.has(d.a);
      var duvod = duvodBlokace(d.a);
      radek.classList.toggle("kkf-ma", ma);
      radek.classList.toggle("kkf-blok", !!duvod);
      var btn = radek.querySelector(".kkf-plus");
      if (btn) {
        btn.setAttribute("aria-pressed", ma ? "true" : "false");
        btn.disabled = !!duvod;
        btn.setAttribute("aria-label",
          duvod ? "Nejde přidat: " + d.t
                : (ma ? "Odebrat z výbavy: " : "Přidat do výbavy: ") + d.t);
        btn.innerHTML = ma ? IKONA_KOS : IKONA_PLUS;
      }
      var p = radek.querySelector(".kkf-dil-duvod");
      if (duvod) {
        if (!p) { p = el("p", "kkf-dil-duvod"); radek.appendChild(p); }
        p.textContent = duvod;
      } else if (p) {
        p.remove();
      }
    }

    function kartaDilu(d, volby) {
      volby = volby || {};
      var radek = el("div", "kkf-dil");
      // číslo artiklu na řádku: ⛔ díly se umí jmenovat stejně, takže se na
      // ně nikde (ani v testech) neodkazuje názvem
      radek.dataset.a = d.a;

      var img = el("img", "kkf-dil-foto");
      img.loading = "lazy";
      img.width = 62; img.height = 62;
      img.alt = "";
      img.src = d.f ? (/^https?:/.test(d.f) ? d.f : cdn + d.f) : "";
      if (!d.f) img.style.visibility = "hidden";
      radek.appendChild(img);

      var stred = el("div");
      var nazev = el("a", "kkf-dil-nazev", d.t);
      nazev.href = "/products/" + d.h;
      nazev.target = "_blank";
      nazev.rel = "noopener";
      stred.appendChild(nazev);
      var meta = el("div", "kkf-dil-meta");
      meta.appendChild(el("span", "kkf-dost kkf-dost-" + d.d, dostText(d)));
      if (d.m && d.m.length) meta.appendChild(el("span", "kkf-znak", "potřebuje další díl"));
      if (maRender(d.a)) meta.appendChild(el("span", "kkf-znak", "ukáže se na motorce"));
      stred.appendChild(meta);
      radek.appendChild(stred);

      var vpravo = el("div", "kkf-dil-vpravo");
      var cena = el("div", "kkf-dil-cena", korunu(d.c));
      if (d.cp && d.cp > d.c) {
        var s = el("s", null, korunu(d.cp));
        cena.appendChild(s);
      }
      vpravo.appendChild(cena);

      if (!volby.bezTlacitka) {
        var btn = el("button", "kkf-plus");
        btn.type = "button";
        btn.addEventListener("click", function () {
          if (vybrano.has(d.a)) { odeber(d.a); } else { pridej(d.a); }
        });
        vpravo.appendChild(btn);
      }
      radek.appendChild(vpravo);
      if (!volby.bezTlacitka) stavKarty(radek, d);
      return radek;
    }

    function sedi(d) {
      if (jenSkladem && d.d > SKLADEM_DO) return false;
      if (!hledanyText) return true;
      return bezDiakritiky(d.t).indexOf(hledanyText) !== -1 ||
             d.a.toLowerCase().indexOf(hledanyText) !== -1;
    }

    function vykresliKategorie() {
      var otevrene = {};
      uzly.kategorie.querySelectorAll("details.kkf-kat").forEach(function (dt) {
        otevrene[dt.dataset.kat] = dt.open;
      });
      uzly.kategorie.innerHTML = "";

      var videno = 0;
      (data.kat || []).forEach(function (par) {
        var klic = par[0], nazev = par[1];
        var vBloku = dily.filter(function (d) { return d.k === klic && sedi(d); });
        if (!vBloku.length) return;
        videno += vBloku.length;
        var vybranoTu = vBloku.filter(function (d) { return vybrano.has(d.a); }).length;

        var det = el("details", "kkf-kat");
        det.dataset.kat = klic;
        // při hledání rozbalit, jinak si pamatovat stav
        det.open = hledanyText ? true : (otevrene[klic] || false);

        var sum = el("summary", "kkf-kat-hl");
        sum.appendChild(el("span", "kkf-nazev", nazev));
        if (vybranoTu) sum.appendChild(el("span", "kkf-kat-ma", String(vybranoTu)));
        sum.appendChild(el("span", "kkf-kat-pocet", String(vBloku.length)));
        var sip = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        sip.setAttribute("viewBox", "0 0 24 24");
        sip.setAttribute("class", "kkf-sipka");
        sip.setAttribute("aria-hidden", "true");
        sip.innerHTML = '<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/>';
        sum.appendChild(sip);
        det.appendChild(sum);

        var telo = el("div", "kkf-kat-telo");
        // díly se staví až při prvním rozbalení (273 dílů najednou je zbytečná práce)
        function naplnit() {
          if (telo.dataset.plno === "1") return;
          vBloku.forEach(function (d) { telo.appendChild(kartaDilu(d)); });
          telo.dataset.plno = "1";
        }
        if (det.open) naplnit();
        det.addEventListener("toggle", function () { if (det.open) naplnit(); });
        det.appendChild(telo);
        uzly.kategorie.appendChild(det);
      });

      uzly.prazdno.hidden = videno > 0;
    }

    function vykresliCipy() {
      uzly.cipy.innerHTML = "";
      var pole = dily.filter(function (d) { return vybrano.has(d.a); });
      uzly.vybrano.hidden = pole.length === 0;
      uzly.vybranoPocet.textContent = String(pole.length);
      pole.forEach(function (d) {
        var li = el("li", "kkf-cip");
        li.dataset.a = d.a;
        li.appendChild(el("span", null, d.t));
        var x = el("button", null, "×");
        x.type = "button";
        x.setAttribute("aria-label", "Odebrat " + d.t);
        x.addEventListener("click", function () { odeber(d.a); });
        li.appendChild(x);
        uzly.cipy.appendChild(li);
      });
    }

    function vykresliSouhrn() {
      var pole = dily.filter(function (d) { return vybrano.has(d.a); });
      var cenaDilu = pole.reduce(function (s, d) { return s + (d.c || 0); }, 0);
      var cenaMoto = data.moto.c || 0;
      uzly.pocet.textContent = String(pole.length);
      var popisVybavy = uzly.cenaDily && uzly.cenaDily.previousElementSibling;
      if (popisVybavy) {
        popisVybavy.textContent = pole.length
          ? "Výbava · " + pole.length + sklonuj(pole.length, " díl", " díly", " dílů")
          : "Výbava";
      }
      var popis = koren.querySelector(".kkf-lista-popis");
      if (popis) {
        popis.textContent = sklonuj(pole.length, "díl ve výbavě", "díly ve výbavě",
                                    "dílů ve výbavě");
      }
      uzly.cenaMoto.textContent = korunu(cenaMoto);
      uzly.cenaDily.textContent = korunu(cenaDilu);
      uzly.cenaCelkem.textContent = korunu(cenaMoto + cenaDilu);
      // ⛔ Motorka do košíku NIKDY — motorky se přes eshop neprodávají, jdou
      //    přes „Nezávazně poptat" (Vít 16. 9.). Do košíku jde jen výbava.
      uzly.doKosikuText.textContent = pole.length ? "Výbavu do košíku" : "Vyber si výbavu";
      uzly.doKosiku.disabled = !pole.length;
    }

    /* ---------- render motorky s díly ---------- */

    // ⚠ Jestli díl má render, ví JEN metapole `konfigurator.rendery` — píše ho
    //    `konfigurator_rendery.py` zvlášť, aby na sobě oba roboti nezáviseli.
    function maRender(artikl) {
      return !!(rendery && rendery.dily && rendery.dily[artikl]);
    }

    function vykresliScenu() {
      if (!rendery || !rendery.uhly || !rendery.uhly.length) return;
      var uhel = rendery.uhly[uhelIx];
      var zaklad = (rendery.zaklad || {})[uhel];
      if (zaklad) uzly.zaklad.src = /^https?:/.test(zaklad) ? zaklad : cdn + zaklad;
      uzly.platno.classList.add("kkf-tmave");
      if (uzly.scena) uzly.scena.classList.add("kkf-tmave");   // pozadí i za zmenšenou fotkou

      uzly.platno.querySelectorAll(".kkf-vrstva").forEach(function (n) { n.remove(); });
      var chybi = 0;
      dily.filter(function (d) { return vybrano.has(d.a); }).forEach(function (d) {
        var url = rendery.dily && rendery.dily[d.a] && rendery.dily[d.a][uhel];
        if (!url) { chybi += 1; return; }
        var v = el("img", "kkf-vrstva");
        v.alt = "";
        v.loading = "eager";   // vznikají až po výběru, jsou to jednotky obrázků
        v.src = /^https?:/.test(url) ? url : cdn + url;
        if (d.a === zvyraznit) v.classList.add("kkf-vrstva-nova");   // oranžový puls
        uzly.platno.appendChild(v);
      });
      zvyraznit = null;

      uzly.scenaStav.hidden = chybi === 0;
      if (chybi) {
        uzly.scenaStav.textContent = chybi === 1
          ? "Jeden vybraný díl se na obrázek zatím nekreslí."
          : chybi + sklonuj(chybi, " vybraný díl se", " vybrané díly se",
                            " vybraných dílů se") + " na obrázek zatím nekreslí.";
      }
      koren.querySelectorAll("[data-otoc]").forEach(function (b) { b.hidden = false; });
      vykresliTecky();
    }

    function vykresliTecky() {
      if (!rendery || !rendery.uhly) return;
      uzly.tecky.hidden = false;
      uzly.tecky.innerHTML = "";
      rendery.uhly.forEach(function (u, i) {
        var t = el("button", "kkf-tecka");
        t.type = "button";
        t.setAttribute("aria-label", "Pohled " + (i + 1) + " z " + rendery.uhly.length);
        t.setAttribute("aria-current", i === uhelIx ? "true" : "false");
        t.addEventListener("click", function () { uhelIx = i; vykresliScenu(); });
        uzly.tecky.appendChild(t);
      });
    }

    /* ---------- odkaz na konfiguraci ---------- */

    // v odkazu jsou jen ZVOLENÉ díly — povinné se dopočítají u příjemce samy
    // ⚠ `location.search` se MUSÍ nést dál: jinak by se z adresy ztratily
    //    parametry kampaní (utm_*) i `?variant=` (nález při revizi 15. 9.)
    function kotva() {
      return zvolene.size ? "#vybava=" + Array.from(zvolene).join(".") : "";
    }

    function odkazNaVybavu() {
      return location.origin + location.pathname + location.search + kotva();
    }

    function doUrl() {
      // ⚠ stav historie se nese dál — drží v něm značku otevřeného okna,
      //    díky které tlačítko Zpět na telefonu okno zavře místo odchodu ze stránky
      history.replaceState(history.state, "", location.pathname + location.search + kotva());
    }

    function zUrl() {
      var m = /[#&]vybava=([A-Za-z0-9.]+)/.exec(location.hash);
      if (!m) return;
      m[1].split(".").forEach(function (a) {
        if (podleArtiklu[a]) zvolene.add(a);
        else chybiZOdkazu++;
      });
    }
    // Odkaz nese jen kódy dílů (nic se neukládá u nás) — díl, který mezitím
    // z nabídky zmizel, se nenačte. Zákazník i skladník to musí vidět.
    var chybiZOdkazu = 0;
    function ohlasChybejici() {
      if (!chybiZOdkazu) return;
      hlaska(chybiZOdkazu + sklonuj(chybiZOdkazu, " díl z odkazu už není v nabídce",
        " díly z odkazu už nejsou v nabídce", " dílů z odkazu už není v nabídce")
        + " — ostatní jsou načtené.", true, true);   // trvale: skladník to musí vidět
      chybiZOdkazu = 0;
    }

    /* ---------- košík ---------- */

    function hlaska(text, chyba, trvale) {
      uzly.hlaska.textContent = text;
      uzly.hlaska.hidden = !text;
      uzly.hlaska.classList.toggle("kkf-chyba", !!chyba);
      clearTimeout(hlaska._t);
      if (text && !trvale) {
        hlaska._t = setTimeout(function () { uzly.hlaska.hidden = true; }, 6000);
      }
    }

    function doKosiku() {
      var polozky = [];      // ⛔ bez motorky — ta se přes eshop neprodává
      dily.filter(function (d) { return vybrano.has(d.a); }).forEach(function (d) {
        if (d.s && d.v) polozky.push({ id: Number(d.v), quantity: 1 });
      });
      if (!polozky.length) {
        hlaska("Do košíku není co vložit — vyber si aspoň jeden díl.", true);
        return;
      }
      var nedostupne = dily.filter(function (d) { return vybrano.has(d.a) && !d.s; });

      uzly.doKosiku.classList.add("kkf-cekam");
      var telo = { items: polozky };
      if (window.miniCart && window.miniCart.getSectionsToRender) {
        var sekce = window.miniCart.getSectionsToRender().map(function (s) { return s.section; });
        telo.sections = sekce.filter(function (s, i) { return sekce.indexOf(s) === i; }).join(",");
        telo.sections_url = location.pathname;
      }
      fetch((koren.dataset.cartAdd || "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/javascript" },
        body: JSON.stringify(telo)
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, data: j }; });
      }).then(function (v) {
        uzly.doKosiku.classList.remove("kkf-cekam");
        if (!v.ok) {
          hlaska(v.data && v.data.description ? v.data.description : "Do košíku se to nepodařilo vložit.", true);
          return;
        }
        koren.dispatchEvent(new CustomEvent("kkf:kosik"));
        if (window.miniCart) {
          try {
            if (v.data.sections) window.miniCart.renderContents(v.data);
            window.miniCart.open();
          } catch (e) { location.href = koren.dataset.cartUrl || "/cart"; }
        } else {
          location.href = koren.dataset.cartUrl || "/cart";
        }
        if (nedostupne.length) {
          hlaska(nedostupne.length
            + sklonuj(nedostupne.length, " díl se do košíku nevešel",
                      " díly se do košíku nevešly", " dílů se do košíku nevešlo")
            + ", nejde je objednat: "
            + nazvy(nedostupne.map(function (d) { return d.a; })), true);
        }
      }).catch(function () {
        uzly.doKosiku.classList.remove("kkf-cekam");
        hlaska("Košík neodpověděl. Zkus to prosím znovu.", true);
      });
    }

    /* ---------- přepočet po každé změně ---------- */

    // Přestavět celý seznam (změna filtru), nebo jen osvěžit stav karet
    function osvezKarty() {
      uzly.kategorie.querySelectorAll(".kkf-dil[data-a]").forEach(function (radek) {
        var d = podleArtiklu[radek.dataset.a];
        if (d) stavKarty(radek, d);
      });
      uzly.kategorie.querySelectorAll("details.kkf-kat").forEach(function (det) {
        var klic = det.dataset.kat;
        var kolik = 0;
        dily.forEach(function (d) { if (d.k === klic && vybrano.has(d.a)) kolik += 1; });
        var znak = det.querySelector(".kkf-kat-ma");
        if (kolik && !znak) {
          znak = el("span", "kkf-kat-ma", String(kolik));
          det.querySelector(".kkf-kat-hl")
             .insertBefore(znak, det.querySelector(".kkf-kat-pocet"));
        } else if (kolik && znak) {
          znak.textContent = String(kolik);
        } else if (znak) {
          znak.remove();
        }
      });
    }

    function poZmene() {
      prepocitejVybrano();
      osvezKarty();
      vykresliCipy();
      vykresliSouhrn();
      vykresliScenu();
      doUrl();
      try {
        sessionStorage.setItem("kkf:" + data.moto.h, JSON.stringify(Array.from(zvolene)));
      } catch (e) { /* soukromé okno — nevadí */ }
    }

    /* ---------- obsluha ---------- */

    uzly.hledani.addEventListener("input", function () {
      hledanyText = bezDiakritiky(uzly.hledani.value.trim());
      uzly.hledaniX.hidden = !uzly.hledani.value;
      vykresliKategorie();
    });
    uzly.hledaniX.addEventListener("click", function () {
      uzly.hledani.value = ""; hledanyText = ""; uzly.hledaniX.hidden = true;
      vykresliKategorie(); uzly.hledani.focus();
    });
    uzly.jenSkladem.addEventListener("change", function () {
      jenSkladem = uzly.jenSkladem.checked;
      vykresliKategorie();
    });
    uzly.doKosiku.addEventListener("click", doKosiku);
    uzly.listaPocet.addEventListener("click", function () {
      uzly.vybrano.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    // Záloha pro prohlížeče, kde `navigator.clipboard` není nebo ho stránka nesmí
    function doSchranky(text) {
      var pole = document.createElement("textarea");
      pole.value = text;
      pole.setAttribute("readonly", "");
      pole.style.cssText = "position:fixed;top:0;left:-9999px";
      document.body.appendChild(pole);
      pole.select();
      var ok = false;
      try { ok = document.execCommand("copy"); } catch (e) { ok = false; }
      pole.remove();
      return ok;
    }

    uzly.sdilet.addEventListener("click", function () {
      var url = odkazNaVybavu();
      var hotovo = function () {
        hlaska(zvolene.size
          ? "Odkaz na tuhle výbavu je ve schránce — můžeš ho poslat dál."
          : "Odkaz na motorku je ve schránce. Vyber si díly a ulož ho znovu.");
      };
      // ⚠ Adresní řádek drží stejnou adresu (history.replaceState), takže když
      //    schránka nejde (starý prohlížeč, zakázané oprávnění), pošleme tam.
      var nejde = function () {
        hlaska("Schránka nejde použít — adresu máš v řádku prohlížeče, zkopíruj ji odtamtud.");
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(hotovo).catch(function () {
          if (doSchranky(url)) { hotovo(); } else { nejde(); }
        });
      } else if (doSchranky(url)) {
        hotovo();
      } else {
        nejde();
      }
    });

    // Motiv má nahoře sticky hlavičku (na mobilu ~143 px) se z-indexem 50 —
    // bez odsazení by nám zakryla obrázek motorky. Výšku měříme za běhu,
    // protože se při rolování mění (hlavička se sbaluje).
    var horniPasy = null;
    function zmerHlavicku() {
      if (koren.classList.contains("kkf-okno")) {
        koren.style.setProperty("--kkf-top", "0px");
        return;
      }
      if (!horniPasy) {
        horniPasy = [].slice.call(document.querySelectorAll("body *")).filter(function (e) {
          if (koren.contains(e)) return false;
          var c = getComputedStyle(e);
          if (c.position !== "sticky" && c.position !== "fixed") return false;
          var b = e.getBoundingClientRect();
          return b.height > 8 && b.height < 260 && b.width > window.innerWidth * 0.7;
        });
      }
      // ⚠ Pruhy se STOHUJÍ: pod hlavičkou (177 px) visí ještě „FILTRUJI NA MOJI
      //    MOTORKU" (44 px). Bere se proto nejnižší okraj těch, které na sebe
      //    navazují, ne jen ten s `top = 0`.
      var dole = 0;
      var zmena = true;
      while (zmena) {
        zmena = false;
        horniPasy.forEach(function (e) {
          var b = e.getBoundingClientRect();
          if (b.top <= dole + 2 && b.bottom > dole && b.bottom < 400) {
            dole = b.bottom;
            zmena = true;
          }
        });
      }
      koren.style.setProperty("--kkf-top", Math.round(dole) + "px");
    }
    zmerHlavicku();
    // ⚠ Seznam pruhů se pamatuje; po dokreslení stránky se musí zahodit,
    //    jinak by nám utekl pruh „FILTRUJI NA MOJI MOTORKU", který přibude až pak.
    setTimeout(function () { horniPasy = null; zmerHlavicku(); }, 1200);
    setTimeout(function () { horniPasy = null; zmerHlavicku(); }, 3000);
    var tikHlavicka = false;
    window.addEventListener("scroll", function () {
      if (tikHlavicka) return;
      tikHlavicka = true;
      requestAnimationFrame(function () { tikHlavicka = false; zmerHlavicku(); });
    }, { passive: true });
    window.addEventListener("resize", function () { horniPasy = null; zmerHlavicku(); });

    // Na mobilu je lišta `position:fixed` — ukázat ji jen když je konfigurátor
    // na obrazovce, jinak by překážela při čtení zbytku karty.
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (zaznamy) {
        if (koren.classList.contains("kkf-okno")) return;   // v okně je lišta vždy
        koren.classList.toggle("kkf-vidim", zaznamy[0].isIntersecting);
      }, { rootMargin: "-10% 0px -25% 0px" }).observe(koren.querySelector(".kkf-mriz"));
    } else {
      koren.classList.add("kkf-vidim");
    }

    // Motiv má na mobilu vlastní spodní panel `#mobile-dock`; naše lišta si
    // o jeho výšku odskočí, aby ho nepřekryla (zjištěno 14. 9. při testu).
    function zmerDock() {
      var v = 0;
      // panel motivu (jen mimo okno — okno ho překrývá)
      var dock = document.getElementById("mobile-dock");
      if (dock && !koren.classList.contains("kkf-okno")
          && getComputedStyle(dock).display !== "none") {
        var r = dock.getBoundingClientRect();
        if (r.height && Math.abs(r.bottom - window.innerHeight) < 2) v = r.height;
      }
      // 🧨 Lišta NÁHLEDU Shopify (iframe #PBarNextFrame) leží NAD naší lištou
      //    i po „Hide bar" a chytá klepnutí — Vít 15. 9.: „Souhrn a tisk nic
      //    nedělá". Zákazník ji nemá; v náhledu se jí uhneme o její výšku.
      var pbar = document.getElementById("PBarNextFrameWrapper");
      if (pbar && getComputedStyle(pbar).display !== "none") {
        var pr = pbar.getBoundingClientRect();
        if (pr.height && pr.bottom > window.innerHeight - 4) v += pr.height;
      }
      koren.style.setProperty("--kkf-dock", v + "px");
    }
    zmerDock();
    window.addEventListener("resize", zmerDock);
    setTimeout(zmerDock, 1200);   // dock se dokresluje po načtení sekcí

    // mobil: při rolování dolů obrázek zmenšit, ať je vidět víc dílů
    var posledniRolovani = 0;
    if (uzly.scenaObal && window.matchMedia("(max-width:900px)").matches) {
      var rolovac = function (y) {
        if (Math.abs(y - posledniRolovani) < 40) return;
        uzly.scenaObal.classList.toggle("kkf-mensi", y > posledniRolovani && y > 260);
        posledniRolovani = y;
      };
      window.addEventListener("scroll", function () {
        if (!koren.classList.contains("kkf-okno")) rolovac(window.scrollY);
      }, { passive: true });
      // V okně se obrázek zmenšuje podle POLOHY s odstupem (hystereze), ne podle
      // směru: zmenšit až za 150 px, zvětšit až pod 40 px. Změna výšky obrázku
      // posune seznam o ~100 px, což je menší než rozestup prahů, takže stav
      // nemůže kmitat (to byla příčina „třese se" 15. 9.). Vít: „když jedu dolů,
      // ať se prostor na karty roztáhne, když nahoru, ať se zase zúží".
      var mensiVOkne = false;
      koren.addEventListener("scroll", function () {
        if (!koren.classList.contains("kkf-okno") || !uzly.scenaObal) return;
        var y = koren.scrollTop;
        if (!mensiVOkne && y > 150) {
          mensiVOkne = true;
          // poměr zmenšení: fotka si drží plnou výšku, jen se transformací srazí na 118 px
          var plna = uzly.platno ? uzly.platno.offsetHeight : 0;
          if (plna > 118) uzly.scenaObal.style.setProperty("--kkf-zoom", (118 / plna).toFixed(4));
          uzly.scenaObal.classList.add("kkf-mensi");
        } else if (mensiVOkne && y < 40) {
          mensiVOkne = false;
          uzly.scenaObal.classList.remove("kkf-mensi");
        }
      }, { passive: true });
      koren.addEventListener("kkf:okno-zavreno", function () { mensiVOkne = false; });
    }

    /* ---------- souhrn: tisk / PDF / poptávka s konfigurací ---------- */

    // Vít 15. 9.: „uložit a vytisknout do PDF … a poslat poptávku s tou konfigurací".
    // Tisk = prohlížeč vytiskne JEN souhrn (@media print), do PDF přes „Uložit jako PDF".
    // Poptávka = předvyplní formulář „Nezávazně poptat" na téže kartě.
    var souhrn = {
      okno: q("[data-kkf-souhrn]"), telo: q("[data-kkf-souhrn-telo]"),
      datum: q("[data-kkf-souhrn-datum]"), url: q("[data-kkf-souhrn-url]"),
      otevrit: q("[data-souhrn]"), tisk: q("[data-kkf-tisk]"), poptat: q("[data-kkf-poptat]")
    };

    function vybraneDily() {
      return dily.filter(function (d) { return vybrano.has(d.a); });
    }

    function souhrnText() {
      var pole = vybraneDily();
      var radky = ["Konfigurace výbavy — " + data.moto.t,
                   "Motocykl: " + korunu(data.moto.c), ""];
      pole.forEach(function (d) {
        radky.push("• " + d.t + " (" + d.a + ") — " + korunu(d.c) + " — " + dostText(d));
      });
      var cenaDilu = pole.reduce(function (s, d) { return s + (d.c || 0); }, 0);
      radky.push("", "Výbava celkem: " + korunu(cenaDilu),
                 "Motocykl + výbava: " + korunu((data.moto.c || 0) + cenaDilu),
                 "", "Odkaz na konfiguraci: " + odkazNaVybavu());
      return radky.join("\n");
    }

    function naplnSouhrn() {
      var pole = vybraneDily();
      var cenaDilu = pole.reduce(function (s, d) { return s + (d.c || 0); }, 0);
      var nazvyKat = {};
      (data.kat || []).forEach(function (par) { nazvyKat[par[0]] = par[1]; });

      // dostupnost je dvakrát: jako sloupec (PC, tisk) a jako řádek pod názvem (mobil)
      function radekPolozky(nazev, kod, dost, cena, trida) {
        var tr = el("tr", trida || null);
        var td = el("td", "kkf-souhrn-polozka");
        td.appendChild(el("span", "kkf-souhrn-nazev", nazev));
        if (kod) td.appendChild(el("span", "kkf-souhrn-kod", "Kód " + kod));
        td.appendChild(el("span", "kkf-souhrn-dost-m", dost));
        tr.appendChild(td);
        tr.appendChild(el("td", "kkf-souhrn-dost", dost));
        tr.appendChild(el("td", "kkf-souhrn-cena", cena));
        return tr;
      }

      var tab = el("table", "kkf-souhrn-tab");
      tab.innerHTML = '<thead><tr><th>Položka</th><th class="kkf-souhrn-dost">Dostupnost</th>'
        + '<th class="kkf-souhrn-cena">Cena</th></tr></thead>';
      var tb = el("tbody");
      tb.appendChild(radekPolozky(data.moto.t, null, dostText(data.moto), korunu(data.moto.c),
        "kkf-souhrn-moto"));
      var posledniKat = null;      // díly jdou v pořadí kategorií (robot je tak řadí)
      pole.forEach(function (d) {
        if (d.k !== posledniKat) {
          posledniKat = d.k;
          var trk = el("tr", "kkf-souhrn-skupina");
          var tdk = el("td", null, nazvyKat[d.k] || "");
          tdk.colSpan = 3;
          trk.appendChild(tdk);
          tb.appendChild(trk);
        }
        tb.appendChild(radekPolozky(d.t, d.a, dostText(d), korunu(d.c)));
      });
      tab.appendChild(tb);

      // součty mimo tabulku — sloupce tabulky se na mobilu mění, blok ne
      var soucty = el("div", "kkf-dok-soucty");
      [["Motocykl", korunu(data.moto.c), null],
       ["Výbava · " + pole.length + sklonuj(pole.length, " díl", " díly", " dílů"),
        korunu(cenaDilu), null],
       ["Celkem", korunu((data.moto.c || 0) + cenaDilu), "kkf-dok-celkem"]
      ].forEach(function (r) {
        var radek = el("div", "kkf-dok-soucet" + (r[2] ? " " + r[2] : ""));
        radek.appendChild(el("span", null, r[0]));
        radek.appendChild(el("strong", null, r[1]));
        soucty.appendChild(radek);
      });

      souhrn.telo.innerHTML = "";
      souhrn.telo.appendChild(tab);
      souhrn.telo.appendChild(soucty);
      souhrn.datum.textContent = new Date().toLocaleDateString("cs-CZ");
      souhrn.url.textContent = odkazNaVybavu();
    }

    function otevriSouhrn() {
      naplnSouhrn();
      souhrn.okno.hidden = false;
      document.body.style.overflow = "hidden";
      souhrn.tisk.focus();
    }
    function zavriSouhrn() {
      souhrn.okno.hidden = true;
      document.body.style.overflow = "";
    }
    if (souhrn.otevrit) souhrn.otevrit.addEventListener("click", otevriSouhrn);
    koren.querySelectorAll("[data-kkf-souhrn-zavri]").forEach(function (b) {
      b.addEventListener("click", zavriSouhrn);
    });

    // Tisk: souhrn se na chvíli zkopíruje přímo do <body>, aby ho motiv (fixed okno,
    // overflow, content-visibility) nemohl při tisku schovat nebo oříznout.
    if (souhrn.tisk) souhrn.tisk.addEventListener("click", function () {
      var kopie = souhrn.okno.querySelector(".kkf-souhrn-okno").cloneNode(true);
      var obal = el("div", "kkf kkf-tisk");
      obal.appendChild(kopie);
      document.body.appendChild(obal);
      document.body.classList.add("kkf-tisknu");
      var uklid = function () {
        document.body.classList.remove("kkf-tisknu");
        obal.remove();
        window.removeEventListener("afterprint", uklid);
      };
      window.addEventListener("afterprint", uklid);
      window.print();
      setTimeout(uklid, 1500);   // prohlížeče bez afterprint
    });

    // Poptávka: formulář „Nezávazně poptat" na kartě motorky (blok request_information)
    function poptatSVybavou() {
      var pole = document.querySelector('textarea[name="contact[comment]"]');
      if (!pole) {
        hlaska("Formulář poptávky na stránce není — použij Uložit odkaz a pošli nám ho.", true);
        return;
      }
      zavriSouhrn();
      zavriOkno(false);
      pole.value = "Dobrý den, mám zájem o tuhle konfiguraci:\n\n" + souhrnText()
        + "\n\nProsím o nabídku.";
      var f = pole.closest("form");
      if (f) {
        var skryte = f.querySelector('input[name="contact[konfigurace]"]');
        if (!skryte) {
          skryte = document.createElement("input");
          skryte.type = "hidden";
          skryte.name = "contact[konfigurace]";
          f.appendChild(skryte);
        }
        skryte.value = odkazNaVybavu();
      }
      // rozbalit sbalený formulář
      var prep = document.querySelector(".product-request-information-toggle");
      if (prep && prep.getAttribute("aria-expanded") !== "true") prep.click();
      setTimeout(function () {
        var kam = (prep || pole).getBoundingClientRect().top + window.scrollY
          - (parseInt(koren.style.getPropertyValue("--kkf-top"), 10) || 0) - 12;
        window.scrollTo({ top: kam, behavior: "smooth" });
        var jmeno = document.getElementById("RequestProductInformationForm-name");
        if (jmeno) setTimeout(function () { jmeno.focus({ preventScroll: true }); }, 600);
      }, 350);
    }
    if (souhrn.poptat) souhrn.poptat.addEventListener("click", poptatSVybavou);

    /* ---------- celoobrazovkové okno (mobil) ---------- */

    // Vít 15. 9.: na mobilu je sekce 15 obrazovek pod koupí a v řádku je to
    // „namáčknuté". Tlačítko u ceny ji otevře přes celý displej; na desktopu
    // jen sjede na sekci, kde je místa dost.
    function jeMobil() { return window.matchMedia("(max-width:900px)").matches; }

    var fokusPredOknem = null;
    function otevriOkno() {
      setTimeout(ohlasChybejici, 400);
      if (!jeMobil()) {
        // ⚠ scrollIntoView tu tiše selže — motiv má sekce s `content-visibility`,
        //    a nevykreslená sekce nemá kam „přijet". getBoundingClientRect ji vynutí.
        var hl = koren.querySelector(".kkf-hlava");
        var odsazeni = parseInt(koren.style.getPropertyValue("--kkf-top"), 10) || 0;
        window.scrollTo({ top: hl.getBoundingClientRect().top + window.scrollY - odsazeni - 12,
                          behavior: "smooth" });
        return;
      }
      fokusPredOknem = document.activeElement;
      koren.classList.add("kkf-okno", "kkf-vidim");
      document.body.classList.add("kkf-otevreno");
      koren.scrollTop = 0;
      zmerDock();
      // okno začíná nahoře s plným obrázkem; zmenšený stav z rolování stránky pryč
      if (uzly.scenaObal) uzly.scenaObal.classList.remove("kkf-mensi");
      posledniRolovani = 0;
      uzly.zaklad.loading = "eager";   // v okně je obrázek první věc, co má být vidět
      zmerHlavicku();
      var z = koren.querySelector("[data-kkf-zavrit]");
      if (z) z.focus();
      history.pushState({ kkf: 1 }, "");
    }
    function zavriOkno(zHistorie) {
      if (!koren.classList.contains("kkf-okno")) return;
      koren.classList.remove("kkf-okno");
      document.body.classList.remove("kkf-otevreno");
      if (uzly.scenaObal) uzly.scenaObal.classList.remove("kkf-mensi");
      koren.dispatchEvent(new CustomEvent("kkf:okno-zavreno"));
      zmerDock();
      if (!zHistorie && history.state && history.state.kkf) history.back();
      // po návratu v historii má adresa starou kotvu — srovnat podle výběru
      setTimeout(doUrl, 50);
      if (fokusPredOknem && fokusPredOknem.focus) fokusPredOknem.focus();
    }
    document.querySelectorAll("[data-kkf-otevrit]").forEach(function (b) {
      b.addEventListener("click", otevriOkno);
    });
    koren.querySelectorAll("[data-kkf-zavrit]").forEach(function (b) {
      b.addEventListener("click", function () { zavriOkno(false); });
    });
    // tlačítko Zpět na telefonu zavře okno místo odchodu ze stránky
    window.addEventListener("popstate", function () { zavriOkno(true); });
    // po vložení do košíku se okno zavře, ať je vidět drawer košíku
    koren.addEventListener("kkf:kosik", function () { zavriOkno(false); });

    /* ---------- start ---------- */
    zUrl();
    if (!window.matchMedia("(max-width:900px)").matches) ohlasChybejici();
    if (!zvolene.size) {
      try {
        var ulozene = JSON.parse(sessionStorage.getItem("kkf:" + data.moto.h) || "[]");
        ulozene.forEach(function (a) { if (podleArtiklu[a]) zvolene.add(a); });
      } catch (e) { /* nevadí */ }
    }
    if (rendery) {
      // výchozí pohled tříčtvrteční jako u KTM, ne zepředu
      var vychozi = (rendery.uhly || []).indexOf("045");
      if (vychozi >= 0) uhelIx = vychozi;
      koren.querySelectorAll("[data-otoc]").forEach(function (b) {
        b.addEventListener("click", function () {
          var krok = Number(b.dataset.otoc);
          uhelIx = (uhelIx + krok + rendery.uhly.length) % rendery.uhly.length;
          vykresliScenu();
        });
      });
    }
    vykresliKategorie();   // první postavení seznamu (dál se už jen osvěžuje)
    poZmene();
    koren.dataset.kkfPripraveno = "1";
  }

  function start() {
    document.querySelectorAll("[data-kkf]").forEach(function (k) {
      if (k.dataset.kkfPripraveno !== "1") Konfigurator(k);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
  // editor motivu překresluje sekce za běhu
  document.addEventListener("shopify:section:load", start);
})();
